var map = {
	"./admin.svg": 1124,
	"./agency.svg": 1125,
	"./basics.svg": 1126,
	"./ceshi.svg": 1127,
	"./course_mall.svg": 1128,
	"./enterprise.svg": 1129,
	"./exam.svg": 1130,
	"./exit.svg": 1131,
	"./finance.svg": 1132,
	"./help.svg": 1133,
	"./horn.svg": 1134,
	"./inform.svg": 1135,
	"./mall.svg": 1136,
	"./message-solid.svg": 1137,
	"./online-service.svg": 1138,
	"./open-course.svg": 1139,
	"./record.svg": 1140,
	"./shop-home.svg": 1141,
	"./shop.svg": 1142,
	"./student.svg": 1143,
	"./system_setup.svg": 1144,
	"./trainer.svg": 1145,
	"./u1372.svg": 1146
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1359;


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 1359
// module chunks = 72